<div class="front-detail-section">
    <div class="section-content" *ngIf="machine">
        <div class="summary">
            <div class="flex-col">
                <div class="flex-row py-1">
                    <div class="detail-title">
                        {{ "status" | lang }}
                    </div>
                    <div class="information">
                        <label
                            class="colorStatus"
                            [ngStyle]="{
                                'background-color': machine.statusFamilyColor
                            }"
                        >
                            {{ machine.statusName }}</label
                        >
                    </div>
                </div>
                <div class="flex-row py-1">
                    <div class="detail-title">
                        {{ since | lang }}
                    </div>
                    <div class="information">
                        {{ machine.lastStatus | fullDateTimePresentation }}
                        {{ "hours" | lang }}
                    </div>

                    <ng-container *ngIf="isJumbo">
                        <div class="detail-title">
                            {{ translateSummary.productionMtsJumbo }}
                            <!-- {{ "perforated_mts" | lang }} -->
                        </div>
                        <div class="information ml-2">
                            {{ machine.totalMeasure }}
                        </div>
                    </ng-container>
                </div>

                <div class="flex-row py-1">
                    <div class="detail-title">
                        {{ translateSummary?.lastProduction }}
                    </div>
                    <div class="information">
                        {{ machine.lastEvent | fullDateTimePresentation }}
                        {{ "hours" | lang }}
                    </div>

                    <div class="detail-title">
                        {{ translateSummary.productionByMachine | pascalcase }}
                    </div>
                    <div class="information ml-2">
                        {{ machine.countMeasure }}
                    </div>
                </div>

                <div class="flex-row py-1">
                    <div class="detail-title">
                        {{ "ubication" | lang }}
                    </div>
                    <div class="information">
                        <span
                            [ngStyle]="{
                                color: machine.isOutOfPark ? '#F05050' : '',
                                'font-weight': machine.isOutOfPark ? '700' : ''
                            }"
                            [ngbTooltip]="
                                machine.isOutOfPark ? tooltipDescription : null
                            "
                        >
                            {{ machine.lastZoneName }}
                        </span>
                    </div>

                    <div class="detail-title">
                        {{ "operator" | lang }}
                    </div>
                    <div class="information ml-2">
                        {{ machine.operatorName }}
                    </div>
                </div>

                <div class="flex-row py-1">
                    <div class="detail-title-comment">
                        {{ "comment" | lang }}
                    </div>
                    &nbsp;<span class="information-comment">
                        {{ machine.comment }}
                    </span>
                </div>
            </div>
        </div>

        <hr class="separator" />

        <div class="time-container">
            <span class="title">{{ "times" | lang | uppercase }}</span
            ><br />
            <div class="time-information">
                <div class="flex-col">
                    <div class="flex-row">
                        <div class="detail-title-time">
                            {{ "time_status" | lang }}
                        </div>
                        <div class="information-time">
                            <label
                                class="colorStatus-time"
                                [ngStyle]="{
                                    'background-color':
                                        machine.statusFamilyColor
                                }"
                            >
                                {{ machine.statusName }}
                            </label>
                        </div>
                        <span class="information-time">{{
                            machine.diffLastStatusText
                        }}</span>
                    </div>
                    <div class="flex-row">
                        <div class="detail-title-time">
                            {{ translateSummary.timeLastProduction }}
                        </div>
                        <span class="information-time">{{
                            machine.diffLastEventText
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
